import { VscSparkle, VscSparkleFilled } from "react-icons/vsc";

export const TicketIcon = ({ isSelected }: { isSelected: boolean }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.00488 9.49976V3.99976C2.00488 3.44747 2.4526 2.99976 3.00488 2.99976H21.0049C21.5572 2.99976 22.0049 3.44747 22.0049 3.99976V9.49976C20.6242 9.49976 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49976 2.00488 9.49976ZM14.0049 4.99976H4.00488V7.96752C5.4866 8.70387 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H14.0049V4.99976ZM16.0049 4.99976V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.70387 20.0049 7.96752V4.99976H16.0049Z"
                fill={isSelected ? "white" : "#A3A8B4"}
            />
        </svg>
    );
};

export const CommunityIcon = ({ isSelected }: { isSelected: boolean }) => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.9999 20.1666C5.93731 20.1666 1.83325 16.0625 1.83325 10.9999C1.83325 5.93731 5.93731 1.83325 10.9999 1.83325C16.0625 1.83325 20.1666 5.93731 20.1666 10.9999C20.1666 16.0625 16.0625 20.1666 10.9999 20.1666ZM8.90077 18.0284C8.0184 16.157 7.47746 14.0929 7.35829 11.9166H3.72332C4.08642 14.8284 6.15661 17.2101 8.90077 18.0284ZM9.19473 11.9166C9.33259 14.1522 9.97124 16.2521 10.9999 18.1059C12.0286 16.2521 12.6672 14.1522 12.8051 11.9166H9.19473ZM18.2765 11.9166H14.6416C14.5224 14.0929 13.9815 16.157 13.0991 18.0284C15.8432 17.2101 17.9134 14.8284 18.2765 11.9166ZM3.72332 10.0833H7.35829C7.47746 7.90687 8.0184 5.84282 8.90077 3.97143C6.15661 4.7898 4.08642 7.17146 3.72332 10.0833ZM9.19473 10.0833H12.8051C12.6672 7.8477 12.0286 5.74765 10.9999 3.89391C9.97124 5.74765 9.33259 7.8477 9.19473 10.0833ZM13.0991 3.97143C13.9815 5.84282 14.5224 7.90687 14.6416 10.0833H18.2765C17.9134 7.17146 15.8432 4.7898 13.0991 3.97143Z"
                fill={isSelected ? "white" : "#A3A8B4"}
            />
        </svg>
    );
};

export const PeopleIcon = ({ isSelected }: { isSelected: boolean }) => {
    return (
        <svg
            width="20"
            height="18"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 21C0 16.5817 3.58172 13 8 13C12.4183 13 16 16.5817 16 21H14C14 17.6863 11.3137 15 8 15C4.68629 15 2 17.6863 2 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10ZM16.2837 13.7028C19.0644 14.9561 21 17.752 21 21H19C19 18.564 17.5483 16.4671 15.4628 15.5271L16.2837 13.7028ZM15.5962 2.41321C17.5944 3.23703 19 5.20361 19 7.5C19 10.3702 16.8042 12.7252 14 12.9776V10.9646C15.6967 10.7222 17 9.264 17 7.5C17 6.11935 16.2016 4.92603 15.041 4.35635L15.5962 2.41321Z"
                fill={isSelected ? "white" : "#A3A8B4"}
            />
        </svg>
    );
};

export const DiscoverIcon = ({ isSelected }: { isSelected: boolean }) => {
    if (isSelected) {
        return <VscSparkleFilled className="h-5 w-5 text-[#A3A8B4]" />;
    }
    return <VscSparkle className="h-5 w-5 text-white" />;
};

export const NotificationIcon = ({
    className,
    fill = "#A3A8B4",
}: {
    className?: string;
    fill?: string;
}) => {
    return (
        <svg
            width="19"
            height="21"
            viewBox="0 0 19 21"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.7338 17.4109H0.0671387V15.5505H1.00047V9.06805C1.00047 4.42812 4.76128 0.666748 9.40047 0.666748C14.0397 0.666748 17.8005 4.42812 17.8005 9.06805V15.5505H18.7338V17.4109ZM2.86714 15.5505H15.9338V9.06805C15.9338 5.45564 13.0087 2.52721 9.40047 2.52721C5.79222 2.52721 2.86714 5.45564 2.86714 9.06805V15.5505ZM7.06714 18.3412H11.7338C11.7338 19.6255 10.6891 20.6667 9.40047 20.6667C8.11182 20.6667 7.06714 19.6255 7.06714 18.3412Z"
                fill={fill}
            />
        </svg>
    );
};

export const CreateEventIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" rx="12" fill="#E2FF05" />
            <path
                d="M11 11V6C11 5.44772 11.4477 5 12 5V5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19V19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12V12C5 11.4477 5.44772 11 6 11H11Z"
                fill="#0F1114"
            />
        </svg>
    );
};
